<template>
  <div class="rule-page">
    <div class="rule-card">
      <button class="close-btn" type="button" @click="closePage">×</button>
      <h1>用户服务条款及隐私政策</h1>
      <div class="rule-content">
        <p>生效日期：2026年01月01日</p>
        <p>公司名称：香港匯赢信息科技有限公司（以下简称“平台/我们”）</p>
        <p>公司地址：ROOM 1002, 10/F, EASEY COMMERCIAL BUILDING, 253-261 HENNESSY ROAD, WAN CHAI HK</p>
        <p>本协议由《用户服务条款》《隐私政策》组成，规范用户与我方的服务使用及个人信息保护相关权利义务。用户注册、登录、浏览、使用本平台服务，即表示自愿阅读、理解并同意本协议全部内容。若用户不认可任一条款，请立即停止使用本平台所有服务。</p>

        <h2>第一部分 用户服务条款</h2>

        <h2>一、服务概述</h2>
        <p>本条款适用于我方官网、APP、小程序、公众号等全部服务载体。我们为用户提供信息展示、功能服务、交互咨询等相关互联网服务，具体内容以平台实际功能为准。我方有权基于业务迭代、系统维护、合规要求调整服务内容与功能，调整后通过平台公告公示即生效，无需单独通知用户。平台服务仅限中国大陆合法合规使用。</p>

        <h2>二、账号使用规则</h2>
        <p>用户注册需提交真实、准确、有效的个人信息，不得伪造、冒用他人信息，信息不实引发的全部风险由用户自行承担。用户需自行妥善保管账号、密码、验证码等信息，账号下所有操作均视为本人操作，因保管不善、转借、泄露账号导致的损失，由用户自行负责。</p>
        <p>用户禁止批量注册、恶意注册、交易账号，禁止利用账号开展刷量、爬虫、恶意营销、违法违规等行为。对违规、异常账号，我方有权采取限流、封禁、注销、终止服务等管控措施。</p>

        <h2>三、用户行为规范</h2>
        <p>用户使用本平台服务，需遵守国家法律法规、网络安全规定及公序良俗，严禁发布、传播违法、低俗、暴力、虚假、侵权等违规内容；严禁攻击、干扰、破解平台系统，爬取、盗用平台数据及内容；严禁冒充他人诈骗、骚扰用户、恶意引流、发布垃圾信息及其他损害平台或第三方权益的行为。用户违规的，我方可删除内容、限制功能、封禁账号，造成损失的需承担相应赔偿及法律责任。</p>

        <h2>四、知识产权</h2>
        <p>平台所有界面、文案、图标、代码、功能设计等内容知识产权均归我方所有，受法律保护，未经我方书面授权，任何第三方不得复制、篡改、转载、商用。用户在平台发布的内容归用户所有，用户授予我方免费、永久、非独占使用权，用于平台运营、内容展示与合规推广。</p>

        <h2>五、服务变更与终止</h2>
        <p>我方因系统维护、故障修复、政策调整等原因，可临时暂停或中断服务，无需承担用户损失。用户存在违规违法行为的，我方有权单方终止服务、注销账号。我方有权适时修订本条款，修订后平台公示即生效，用户继续使用服务视为认可更新条款。</p>

        <h2>六、免责声明</h2>
        <p>我方按现有技术标准提供服务，不保证服务完全无故障、无中断。因网络异常、设备问题、用户操作失误、不可抗力等第三方因素造成的损失，我方不予免责。平台不对用户自主发布内容的真实性、合法性作绝对担保，相关风险由用户自行承担。本条款未免除我方法定责任、未加重用户责任、未排除用户合法权益，符合合规要求。</p>

        <h2>第二部分 隐私政策</h2>
        <p>生效日期：2026年01月01日</p>
        <p>依据《个人信息保护法》《网络安全法》等法律法规，我方制定本隐私政策，规范用户个人信息收集、使用、存储、保护等行为。用户使用本平台服务，即同意本政策内容。</p>

        <h2>一、信息收集</h2>
        <p>我们仅收集服务必需的用户信息，不收集无关信息。一是用户主动提交的信息，包括昵称、手机号、头像、联系地址、反馈内容及其他主动上传的信息；二是系统自动获取的信息，包括设备型号、系统版本、IP地址、访问记录、操作日志、网络状态等技术数据。非必要信息用户可自主选择是否提供，不影响基础服务使用；核心服务必需信息缺失的，将无法使用对应功能。</p>

        <h2>二、信息使用</h2>
        <p>我方收集的信息仅用于：保障账号注册、登录及账号安全；提供平台功能服务、售后咨询与问题处理；优化产品体验、迭代服务功能；推送必要的系统通知与公告；防范风险、保障平台安全；配合监管及司法机关合法调查；经用户单独授权的其他场景。绝不超范围、超目的使用用户个人信息。</p>

        <h2>三、信息存储与安全</h2>
        <p>用户数据均存储于境内合规服务器，我方通过数据加密、权限隔离、安全审计、风险监测等技术及管理制度保护用户信息安全，定期开展安全维护。数据仅在服务所需、法定履约的最短期限内留存，到期后统一脱敏、删除或销毁。若发生信息安全事件，我方将及时采取补救措施，并依法报备、告知用户。</p>

        <h2>四、信息共享与披露</h2>
        <p>我方不会出售、出租、无故共享用户个人信息。仅为保障服务运行，可向合作服务商提供必要信息，并要求第三方严格保密、合规使用。遇司法裁定、监管合法调查、维护公共利益等法定情形，我方可依法披露用户相关信息。</p>

        <h2>五、用户隐私权利</h2>
        <p>用户依法享有个人信息知情权、访问权、更正权、删除权、授权撤回权、账号注销权及投诉举报权。用户可随时核查、更正个人信息，在法定情形下申请删除数据、撤回授权、注销账号，我方将依规处理。用户认为我方侵害其隐私权益的，可通过平台官方渠道反馈。</p>

        <h2>六、Cookie 与未成年人保护</h2>
        <p>平台可使用Cookie等技术识别用户、优化访问体验，用户可手动清理或拒绝，可能导致部分功能异常。平台重视未成年人隐私保护，未成年人需在监护人知情同意下使用服务，发现违规收集的未成年人信息将立即删除。</p>

        <h2>七、政策更新</h2>
        <p>我方可根据法律法规及业务调整更新本政策，更新后通过平台公示生效，用户继续使用服务即视为认可新版本政策。</p>

        <h2>第三部分 通用附则</h2>
        <p>1. 本服务条款与隐私政策为完整协议，具有同等法律效力。</p>
        <p>2. 本协议未尽事宜，适用中华人民共和国现行法律。</p>
        <p>3. 双方争议优先协商解决，协商不成，由我方主体所在地人民法院管辖。</p>
        <p>4. 本协议任一条款无效，不影响其他条款效力。</p>
      </div>
      <button class="confirm-btn" type="button" @click="closePage">确定</button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'RulePage',
  methods: {
    closePage() {
      if (window.history.length > 1) {
        this.$router.back()
      } else {
        this.$router.push('/')
      }
    }
  }
}
</script>

<style scoped>
.rule-page {
  min-height: 100vh;
  background: #f5f5f5;
  padding: 16px;
  box-sizing: border-box;
}
.rule-card {
  position: relative;
  max-width: 900px;
  margin: 0 auto;
  background: #fff;
  border-radius: 16px;
  padding: 20px 16px 20px;
  box-shadow: 0 8px 24px rgba(0, 0, 0, 0.06);
}
.close-btn {
  position: absolute;
  right: 12px;
  top: 8px;
  border: none;
  background: transparent;
  font-size: 28px;
  color: #999;
  line-height: 1;
}
.rule-card h1 {
  margin: 0 0 18px;
  text-align: center;
  font-size: 22px;
  color: #111;
}
.rule-content {
  color: #333;
  font-size: 14px;
  line-height: 1.8;
  max-height: calc(100vh - 180px);
  overflow-y: auto;
}
.rule-content h2 {
  margin: 18px 0 8px;
  font-size: 16px;
  color: #111;
}
.rule-content p {
  margin: 0 0 10px;
}
.confirm-btn {
  margin-top: 14px;
  width: 100%;
  height: 44px;
  border: none;
  border-radius: 22px;
  background: #f4cd16;
  color: #d4451f;
  font-size: 16px;
  font-weight: 700;
}
</style>
